// extracted by mini-css-extract-plugin
export var backdropBlur = "_hn-0";
export var contentCard = "_hn-5";
export var frame = "_hn-2";
export var image = "_hn-4";
export var imagePane = "_hn-3";
export var modal = "_hn-1";